import { render, staticRenderFns } from "./PerfilTrabajador.vue?vue&type=template&id=61218066"
import script from "./PerfilTrabajador.vue?vue&type=script&lang=js"
export * from "./PerfilTrabajador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports